//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getUserInfo } from '@/util/const'
import { setAuthorization, setBossToken } from '../../axios/userInfo'

export default {
  data () {
    return {
      status: false,
      tag: '',
      tagHref: {
        series_update: 'openpage://3520',
        recommend_update: 'openpage://8600'
      }
    }
  },
  created () {
    this.clickRate()
    window.getUserTag = (obj) => {
      if (obj) {
        setAuthorization(obj.authorization)
        if (obj.boss) {
          setBossToken(obj.boss.access_token)
          this.userTag()
        }
      }
    }
    getUserInfo({ callbackName: 'getUserTag', needLogin: true })
    window.getUserInfo = (obj) => {
      console.log(obj)
      if (obj) {
        setAuthorization(obj.authorization)
        if (obj.boss) {
          setBossToken(obj.boss.access_token)
        }
        this.ifGetFlow().then(res => {
          if (res.data.header.resultCode === 0) {
            if (res.data.body.if_getflow) {
              this.$confirm({
                content: this.$t('easter.easter13'),
                buttonText: [
                  {
                    id: 'cancel',
                    text: this.$t('easter.easter15')
                  }
                ]
              }).catch(() => {
                console.log('no')
              })
            } else {
              this.getFlow().then(res => {
                if (res.data.header.resultCode === 0) {
                  if (res.data.body.result) {
                    this.$router.replace({ path: '/easterSuccess' })
                  } else {
                    this.$confirm({
                      content: this.$t('easter.easter16'),
                      buttonText: [
                        {
                          id: 'cancel',
                          text: this.$t('easter.easter15')
                        }
                      ]
                    }).catch(() => {
                      console.log('no')
                    })
                  }
                }
              })
            }
          }
        })
      }
    }
  },
  methods: {
    clickRate () {
      let time = new Date().getTime()
      let param = {
        'records': [{
          'clickTime': time,
          'umparam': 'id',
          'umvalue': '1',
          'umkey': 'easter_flow',
          'devicedId': '123456'
        }]
      }
      this.$http.post(`/v1/api/ad/clickRate-Web`, { body: param }).then(res => {

      })
    },
    detail () {
      this.$alert({
        content: {
          title: this.$t('easter.easter11'),
          list: this.$t('easter.easter12')
        }
      })
    },
    ifGetFlow () {
      return (async () => {
        return await this.$http.get(`/v1/api/ad/gift/flow/if_getflow`)
      })()
    },
    getFlow () {
      return (async () => {
        return await this.$http.get(`/v1/api/ad/gift/flow/getFlow`)
      })()
    },
    userTag () {
      this.$http.get(`/v1/api/ad/gift/flow/userTag`).then(res => {
        if (res.data.header.resultCode === 0) {
          let list = res.data.body.tag_list
          if (!list || (list && list.length === 0)) {
            this.tag = ''
          } else if (list.indexOf('series_update') !== -1) {
            this.tag = 'series_update'
          } else if (list.indexOf('recommend_update') !== -1) {
            this.tag = 'recommend_update'
          } else {
            this.tag = ''
          }
        }
      })
    },
    receive () {
      if (!this.status) {
        return
      }
      getUserInfo({ callbackName: 'getUserInfo', needLogin: true })
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/easter/index.vue